import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';

import { MainSidenavService } from '../../../main-sidenav.service';
import {
  AppNotificationsService,
  ProviderConfig,
} from '../../../services/app-notifications.service';
import { PERMISSIONS } from '../../../services/permissions/permissions.service';

/** Único proveedor de email soportado por este panel; no es editable por el usuario. */
const EMAIL_PROVIDER_ID = 'mandrill';

@Component({
  selector: 'app-app-notifications',
  templateUrl: './app-notifications.component.html',
  styleUrls: ['./app-notifications.component.scss'],
})
export class AppNotificationsComponent implements OnInit {
  appId: string;
  loading = true;
  saving = false;

  PERMISSIONS = PERMISSIONS;

  /** Config completa devuelta por el backend; solo editamos `enabled`, `providerId` va fijo. */
  emailConfig: ProviderConfig = { providerId: EMAIL_PROVIDER_ID, enabled: false };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private notificationsApi: AppNotificationsService,
    public mainSidenavService: MainSidenavService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.appId = this.route.snapshot.paramMap.get('id');
    this.loadConfig();
  }

  loadConfig() {
    this.loading = true;
    this.notificationsApi.getEmailConfig(this.appId).subscribe(
      (config) => {
        this.emailConfig = config || { providerId: EMAIL_PROVIDER_ID, enabled: false };
        this.emailConfig.providerId = EMAIL_PROVIDER_ID;
        this.loading = false;
      },
      (error: HttpErrorResponse) => {
        this.loading = false;
        if (error.status === 404) {
          // No hay configuración previa para esta app
          this.emailConfig = { providerId: EMAIL_PROVIDER_ID, enabled: false };
          return;
        }
        this.processHttpError('Error obteniendo configuración de email', error);
      }
    );
  }

  save() {
    this.emailConfig.providerId = EMAIL_PROVIDER_ID;
    this.saving = true;
    this.notificationsApi.setEmailConfig(this.appId, this.emailConfig).subscribe(
      (config) => {
        this.saving = false;
        if (config) {
          this.emailConfig = config;
        }
        this.snackBar.open('Configuración guardada', 'OK', { duration: 3000 });
        this.router.navigateByUrl('/pages/apps');
      },
      (error: HttpErrorResponse) => {
        this.saving = false;
        this.processHttpError('Error guardando configuración de email', error);
      }
    );
  }

  cancel() {
    this.router.navigateByUrl('/pages/apps');
  }

  private processHttpError(log: string, error: HttpErrorResponse) {
    console.error(log, error);
    let msg = 'Error de comunicación';
    if (error.status >= 400 && error.status < 500) {
      msg = 'Acceso denegado';
    }
    msg += `: ${error.status} ${error.statusText}: ${JSON.stringify(error.error)}`;
    this.snackBar.open(msg, 'OK');
  }
}
